import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface VersionInfo {
    id: string;
    major: number;
    minor: number;
    patch: number;
    preReleaseNumber: number | null;
    developmentStage: number;
    releaseDate: string;
    versionName?: string;
    pdfPath?: string;
    versionNumber?: string; // Derived string for display
}

@Injectable({
    providedIn: 'root'
})
export class VersionService {
    private versionSubject = new BehaviorSubject<string>('');
    public version$ = this.versionSubject.asObservable();

    private versionInfoSubject = new BehaviorSubject<VersionInfo | null>(null);
    public versionInfo$ = this.versionInfoSubject.asObservable();

    constructor(private http: HttpClient) {
        this.fetchLatestVersion();
    }

    private getBaseUrl(): string {
        const communicationUrl = environment.apiLocations.communication;
        const url = new URL(communicationUrl);
        return url.origin;
    }

    private constructVersionString(v: any): string {
        const major = v.major !== undefined ? v.major : (v.Major !== undefined ? v.Major : undefined);
        const minor = v.minor !== undefined ? v.minor : (v.Minor !== undefined ? v.Minor : undefined);
        const patch = v.patch !== undefined ? v.patch : (v.Patch !== undefined ? v.Patch : undefined);

        let finalVersion: string;
        if (major !== undefined && major !== null) {
            finalVersion = `${major}.${minor}.${patch}`;
        } else {
            const oldVN = v.versionNumber || v.VersionNumber || '0.0.0';
            finalVersion = oldVN.split('-')[0]; // Strip suffix if any
        }

        return finalVersion.startsWith('v') ? finalVersion : `v${finalVersion}`;
    }

    fetchLatestVersion(): void {
        this.http.get<any>(`${environment.apiLocations.communication}/version-management/latest`)
            .subscribe({
                next: (response) => {
                    if (response && response.isSuccess && response.data) {
                        const v = response.data;
                        const versionStr = this.constructVersionString(v);
                        this.versionSubject.next(versionStr);

                        const pdfUrl = v.pdfPath
                            ? `${environment.apiLocations.communication}/version-management/${v.id}/pdf`
                            : undefined;

                        this.versionInfoSubject.next({
                            id: v.id,
                            major: v.major,
                            minor: v.minor,
                            patch: v.patch,
                            preReleaseNumber: v.preReleaseNumber,
                            developmentStage: v.developmentStage,
                            releaseDate: v.releaseDate,
                            versionName: v.versionName,
                            pdfPath: pdfUrl,
                            versionNumber: versionStr
                        });
                    }
                },
                error: (err) => {
                    console.error('Failed to fetch latest version in VersionService', err);
                }
            });
    }
}
